import React from "react";

import {
    Box,
    Grid,
    Typography
} from "@mui/material";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import SocialIcon from "./social-icon/social-icon";

export class Footer extends React.Component<{}, { footerJson: any }> {

    constructor(props: any) {
        super(props)

        this.state = {
            footerJson: null
        }
    }

    componentDidMount(): void {
        fetch(process.env.PUBLIC_URL + '/loaded-files/footer_definition.json').then((res) => res.json()).then((data) => {
            this.setState(() => ({ footerJson: data }));
        })
    }

    render() {
        return (<>
            {this.state.footerJson !== null && <Box
                sx={{
                    p: 6,
                    mt: "auto",
                    zIndex: (theme) => theme.zIndex.drawer,
                }}
                style={{
                    background: process.env.REACT_APP_THIRD_COLOR,
                    boxShadow: "none"
                }}>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body2" sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }}>
                            &copy; {this.state.footerJson.startCopyrightYear} {this.state.footerJson.copyrightEndsCurrentYear && <Box component={"span"}> - {new Date().getFullYear()}</Box>} {!this.state.footerJson.copyrightEndsCurrentYear && <> - {this.state.footerJson.endCopyrightYear}</>}
                        </Typography>
                        <Box sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }}>
                            <ReactMarkdown>{this.state.footerJson.companyName as string}</ReactMarkdown>
                        </Box>
                        {this.state.footerJson.footerRows.map((item: string) => (<Box key={item}>
                            <Box sx={{ color: process.env.REACT_APP_DEFAULT_TEXT_COLOR }}>
                                <ReactMarkdown>
                                    {item}
                                </ReactMarkdown>
                            </Box>
                        </Box>))}
                    </Grid>
                    <Grid item xs={12} md={6}
                        sx={{
                            px: 2
                        }}
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"flex-end"}
                        justifyContent={"right"}>
                        {this.state.footerJson.socialUrls.map((item: any) => (
                            <SocialIcon key={item} social={item.social} url={item.url} />
                        ))}
                    </Grid>
                </Grid>
            </Box>}
        </>);
    }
}
